module.exports = __webpack_public_path__ + "csv_templates/lesson_set-d41d8cd98f00b204e9800998ecf8427e.csv";